import { REDIRECT } from 'client/actions/constants';

export function redirect({ path }) {
  return {
    type: REDIRECT,
    path,
  };
}
